import React, { FC } from 'react';

import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_left_button: [
      'close - button1',
      'close - button2',
      'close - button3'
    ],
    multi_right_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ]
  }
};

const BottomSheetSlideTracking: FC = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;
    
    position: relative;
    overflow: hidden;
    
    .modal_wrapper {
      width: 100%;
      height: 20.5rem;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      background-color: transparent;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      height: 16rem;
      outline: none;
    }
    .slick-track {
      display: flex;
    }
    .slick-track img {
      object-fit: cover;
    }
    .slick_page {
      padding: 0.25rem 1rem;
      position: absolute;
      top: 1rem;
      right: 1rem;

      display: flex;
      gap: 0.25rem;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .contents_wrapper {
      width: 100%;
      margin-top: 1.5rem;
      padding: 0 10%;

      position: absolute;
      top: 0;
      z-index: 1;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;
      margin-bottom: 0.5rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title {
      width: 100%;
      height: 1.875rem;

      display: flex;
      align-items: center;
    }

    .slick-slider {
      position: relative;
    }
    .dot_wrapper {
      width: 100%;
      position: absolute;
      bottom: 1rem;
      z-index: 999;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;      
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }
    .dot_wrapper button {
      width: 0.25rem;
      height: 0.25rem;

      font-size: 0;
      border: 0;
      outline: 0;
      border-radius: 999px;
      background-color: rgba(0, 0, 0, .3);
    }
    .dot_wrapper li.slick-active button {
      background-color: #000;
    }

    .bottom_wrapper {
        width: 100%;
        min-height: 25.6px;

        position: absolute;
        right: 0;
        bottom: 6.75rem;
    }

    .btn_wrapper {
      width: 100%;
      height: 5rem;

      position: absolute;
      right: 0;
      bottom: 0;
    }
    .btn_inner {
        height: 40px;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="modal_wrapper">
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div className="contents_wrapper" />
          <div className="btn_wrapper">
            <div className="btn_inner tracking_center">
              <EditTracking
                value={tracking?.multi_left_button?.[currentIndex]}
                type="multi_left_button"
              />
            </div>
            <div className="btn_inner tracking_center">
              <EditTracking
                value={tracking?.multi_right_button?.[currentIndex]}
                type="multi_right_button"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomSheetSlideTracking;
